export default __webpack_public_path__ + "static/media/cta1.35dfe0e9.png";